import React from "react";

const Loading = ({ fullScreen = false }) => {
  return (
    <div
      className={`loading${fullScreen ? " is-fullscreen" : ""}`}
      role="status"
      aria-label="Loading"
    >
      <div className="loading__track">
        <div className="loading__bar" />
      </div>
    </div>
  );
};

export default Loading;
